/* KudosSkeleton.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._yv0e4uu2%7Bgrid-template-columns%3Arepeat(auto-fill%2Cminmax(200px%2C1fr))%7D");
import React from 'react';
import { Grid } from '@atlaskit/primitives/compiled/grid';
import { LoadingSkeleton } from '@townsquare/loading-skeleton';
import { BROWSE_KUDOS_CARD_SLOTS } from './constants';
const styles = {
  kudosLoadingStyles: "_yv0e4uu2"
};
export const KudosRowSkeleton = (): React.JSX.Element => <Grid gap="space.200" xcss={styles.kudosLoadingStyles}>
		{[...Array(BROWSE_KUDOS_CARD_SLOTS)].map((_, i) => <LoadingSkeleton width="100%" height="220px" marginTopPx={5} key={i} />)}
	</Grid>;